import styled from "styled-components";

export const PreviewModalStyle = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  .previewWrapper {
    height: 100%;
    section {
      margin-bottom: 10px;
      height: 70%;
      img {
        max-height: 100%;
      }
    }
  }
  header {
    font-size: 1.62rem;
    font-weight: 700;
    height: 10%;
    color: antiquewhite;
    margin: 20px 0;
  }
  section {
    width: 100%;
    height: 80%;
    padding: 10px;
    max-height: 500px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  footer {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
    height: 10%;
    .textareaInput {
      font-size: 1rem;
      padding: 4px;
      width: 80%;
      resize: none;
      outline: none;
      height: auto;
      max-height: 500px;
      background-color: #2c2f35;
      min-height: 50px;
      color: white;
    }
    .textareaInput:focus {
      border-color: #719ece;
      box-shadow: 0 0 20px #719ece;
      color: white;
    }
    .uploadBtn {
      padding: 2px 10px;
      border-radius: 20px;
      font-size: 1.3rem;
      background-color: lightgreen;
      color: black;
    }
  }
  @media only screen and (max-width: 600px) {
    section {
      height: max-content;
      margin-bottom: 50px;
    }

    footer {
      flex-direction: column;
      .textareaInput {
        width: 100%;
        min-height: 80px;
        margin-bottom: 30px;
      }
    }
  }
`;

export const HomeWrapper = styled.div`
  text-align: center;
  width: 100%;
  word-wrap: break-word;
  background-color: #1a1a1d;
  height: 100%;
  background-color: inherit;
  .head,
  .AlbumName {
    font-size: 2.5rem;
    margin: 1rem;
    color: #1db954;
    font-weight: 700;
  }
  /* .AlbumName {
    font-size: 1.5rem;
    margin: 20px;
    color: rebeccapurple;
    font-weight: 700;
  } */
  h6 {
    font-weight: lighter;
  }
  #FileUpload {
    display: none;
  }
  label {
    margin-top: 20px;
    cursor: pointer;
    i {
      color: #e85a4f;
    }
  }
  .searchContainer {
    display: block;
    width: 80%;
    overflow: hidden;
    font-size: 1rem;
    min-width: 300px;
    background-color: #e2e2e2;
    border-radius: 500px;
    margin: 20px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    input {
      width: 87%;
      border-radius: 500px;
      background-color: inherit;
      outline: none;
      border: none;
      padding: 10px 20px;
    }
    i {
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .dateFilterContainer {
    display: flex;
    justify-content: center;
    /* background-color: salmon; */
    label {
      color: whitesmoke;
      margin: 0 40px;
      span::after {
        padding-left: 5px;
      }
      input {
        padding: 5px;
        margin: 5px 15px;
        background-color: inherit;
        outline: none;
        border: 2px solid salmon;
        color: whitesmoke;
      }
      input[type="date"]::-webkit-calendar-picker-indicator {
        filter: invert(1);
        cursor: pointer;
      }
      input:invalid + span::after {
        content: "✖";
        color: red;
        font-weight: bolder;
      }

      input:valid + span::after {
        content: "✓";
        color: green;
        font-weight: bolder;
      }
    }
    .resetDateBtn {
      font-size: 1.3rem;
      padding: 3px 10px;
      background-color: inherit;
      outline: none;
      color: whitesmoke;
      border-radius: 600px;
      /* font-weight: 700; */
      border: 2px solid salmon;
    }
  }

  @media only screen and (max-width: 550px) {
    .dateFilterContainer {
      display: flex;

      flex-direction: column;
    }
  }

  @media only screen and (max-width: 350px) {
    .head {
      font-weight: lighter;
    }
  }
`;
